module.exports = __webpack_public_path__ + "img/operational_planning_en.fa1b253d.svg";